import { useTranslation } from "react-i18next"

const src = require("../../assets/img/loading-light.gif").default

export const AsyncButton = ({ name, sendingName, sending, onClick }) => {
  const { t } = useTranslation()

  name = name ? name : t(`ui.btns.submit`)
  sendingName = sendingName ? sendingName : t(`ui.btns.submiting`) + "..."

  return (
    <>
      <button
        onClick={onClick}
        disabled={sending}
        type="submit"
        className="d-inline-flex align-items-center btn btn-primary mx-1"
      >
        {sending && <img alt="gif" src={src} width="16" className="me-2" />}
        {sending ? sendingName : name}
      </button>
    </>
  )
}
